import { createReducer, on } from '@ngrx/store';

import { Breakpoint } from '../../../../../breakpoints/config';
import { setBreakpoint } from './breakpoint.actions';

export interface BreakpointState {
  breakpoints: Record<Breakpoint, boolean>;
}

export const initialState: BreakpointState = {
  breakpoints: {
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false,
  },
};

export const breakpointFeatureKey = 'breakpoint';

export const breakpointReducer = createReducer(
  initialState,

  on(
    setBreakpoint,
    (state, { breakpoint, matched }): BreakpointState => ({
      ...state,
      breakpoints: {
        ...state.breakpoints,
        [breakpoint]: matched,
      },
    })
  )
);
